export default class Footer {
    constructor(root) {
        this.root = root;

        if(this.root.classList.contains('--fixed')) {
            this.last_scrolltop = window.scrollY;

            document.addEventListener('scroll', () => { this.scrolling(window.scrollY) });

            //show correct nav on page load
            this.scrolling(window.scrollY);
        }
    }

    scrolling(position) {
        if(position > 250 && position < document.body.scrollHeight - window.innerHeight - 250) {
            this.root.classList.add('--active');
        } else {
            this.root.classList.remove('--active');
        }

        this.last_scrolltop = window.scrollY;
    }
}
